<template>
  <div>
    <spacer :y="5"/>
    <ul>
      <stack-item id="scroll-top">
        <contents-box title="送信済みメッセージ">
          <p :class="$style.label">＊最新の状態を反映するにはリロードしてください</p>
          <spacer :y="3"/>
          <loader-simple :flag="flag.messageLoader">
            <p v-if="!messagegroups && !flag.messageLoader">送信履歴はありませんでした。</p>
            <ul v-if="messagegroups && !flag.messageLoader">
              <stack-item space="2" :class="$style.new_wrap"
                v-for="(item, i) of displayGroups"
                :key="i">
                <!-- 一覧クリックは遷移のみ。既読化は遷移先(MessageDetail)の表示時に登録する -->
                <user-box
                  v-if="item.sender"
                  :showId="true"
                  :showAge="item.sender.account_type > 10 ? false : true"
                  :user="item.sender"
                  :link="`/operator/text/${item.group.id}`"
                  :targetBlank="true">
                  <template v-slot:main>
                    <div :class="$style.message" v-if="messages[item.group.id]">
                      <spacer :y="1"/>
                      <p>{{ messages[item.group.id] }}</p>
                    </div>
                  </template>
                </user-box>
                <div
                  :class="$style.new"
                  v-if="user.readflags && newFlags.includes(item.group.id)">NEW</div>
              </stack-item>
            </ul>
          </loader-simple>

          <div v-show="showMore">
            <spacer :y="4" />
            <loader-simple
              :flag="flag.loader"
              :mini="true"
            >
              <btn-container>
                <basic-btn
                  tag="button"
                  :disabled="flag.loader"
                  v-on:click="loadMore">
                  <sapn>もっと見る</sapn>
                </basic-btn>
              </btn-container>
            </loader-simple>
          </div>

        </contents-box>
      </stack-item>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ContentsBox from '@/views/components/ContentsBox.vue';
import StackItem from '@/views/components/StackItem.vue';
import Spacer from '@/views/components/Spacer.vue';
import LoaderSimple from '@/views/components/LoaderSimple.vue';
import UserBox from '@/views/components/UserBox.vue';
import BtnContainer from '@/views/components/BtnContainer.vue';
import BasicBtn from '@/views/components/BasicBtn.vue';
import cf from '@/mixins/commonFunctions';

export default {
  name: 'Message',
  mixins: [cf],
  components: {
    ContentsBox,
    StackItem,
    Spacer,
    UserBox,
    LoaderSimple,
    BtnContainer,
    BasicBtn,
  },
  data() {
    return {
      initialMessage: null,
      messagegroups: [],
      messages: {},
      rawMessages: {},
      newFlags: [],
      flag: {
        loader: false,
        messageLoader: true,
        noUsers: false,
      },
      perPage: 20,
      page: 0,
      lastPage: 0,
    };
  },
  created() {
    if (this.user.counseling.operator) {
      this.getOperatorMessage();
    } else {
      this.$store.subscribe((mutation) => {
        if (mutation.type === 'user/counseling/putOperatorMessage') {
          this.getOperatorMessage();
        }
      });
    }
  },
  computed: {
    ...mapState(['user', 'helper']),
    showMore() {
      return this.page < this.lastPage;
    },
    messageGroupIds() {
      return this.messagegroups.map((mg) => mg.id);
    },
    // 各ルームと、一覧に表示する送信者の組を返す。送信者解決ロジックは resolveRoomSender 参照
    displayGroups() {
      return this.messagegroups.map((group) => ({
        group,
        sender: this.resolveRoomSender(group),
      }));
    },
  },
  methods: {
    /**
     * 一覧に表示する送信者を解決する。
     * 事務局↔学校管理者の学校共有ルーム(target_type=4)は対象者(target_user_id)を持たないため、
     * 「最後に school 側(account_type 3/11/12)が送信したメッセージの送信者」を rawMessages の末尾走査で表示する。
     * （rawMessages は updated_at 昇順＝末尾が最新なので末尾から探す）。
     * school 側送信者がまだ居ないルームは backend が attach した主管理者(11)へフォールバックする。
     * type=4 以外は従来どおり対象者(fromUser)を表示する。
     */
    resolveRoomSender(group) {
      if (Number(group.target_type) !== 4) return group.fromUser;
      const messages = this.rawMessages[group.id] || [];
      const schoolSideAccountTypes = [3, 11, 12];
      for (let i = messages.length - 1; i >= 0; i -= 1) {
        const sender = messages[i].user;
        if (sender && schoolSideAccountTypes.includes(sender.account_type)) return sender;
      }
      return group.fallbackSchoolManager || group.fromUser;
    },

    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },
    /** ローディング非表示 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    /** メッセージ取得 */
    getOperatorMessage() {
      // 多重実行防止
      if (this.flag.loader) {
        return;
      }
      this.flag.loader = true;

      const params = {
        user_id: this.user.id,
        target_type: 2,
        includeSchoolRoom: 1, // carve 後の type=4 学校共有ルームも一覧に含める（#3185 ②）
        isMessages: 1,
        limit: this.perPage,
        page: this.page + 1,
      };
      this.axios({
        method: 'GET',
        url: '/v1/messagegroup/get/listOrderByNewest', // 新着順で取得する
        params,
      })
        .then(async (response) => {
          const res = response.data;

          // ページ関連
          this.page = res.groups.page;
          this.lastPage = res.groups.lastPage;

          // 取得したデータを表示用の配列に格納する（重複は除く）
          res.groups.data.forEach((data) => {
            if (!this.messageGroupIds.includes(data.id)) {
              this.messagegroups.push(data);
            }
          });

          await this.setMessage(res);
          await this.newFlagsChecker(res);
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        })
        .finally(() => {
          this.flag.messageLoader = false;
          this.flag.loader = false;
        });
    },

    setMessage(res) {
      if (res && res.groups && res.groups.data) {
        const groups = res.groups;
        groups.data.forEach((message) => {
          if (message.messages.length) {
            this.rawMessages[message.id] = message.messages;
          } else {
            this.rawMessages[message.id] = [];
          }

          // プレビュー本文は group の id で保持する。学校共有ルーム(target_type=4)は target_user_id を持たず、
          // target_user_id キーだと複数ルームが messages[null] で衝突するため id でキーする。
          if (message.messages && message.messages.length) {
            const targetMessage = message.messages[message.messages.length - 1];
            this.messages[message.id] = targetMessage.message;
          } else {
            this.messages[message.id] = 'メッセージ履歴がありません';
          }
        });
      }
    },

    newFlagsChecker(res) {
      if (res && res.groups && res.groups.data) {
        const groups = res.groups;
        groups.data.forEach((message) => {
          if (message.messages && message.messages.length) {
            const targetMessage = message.messages[message.messages.length - 1];
            if ((this.user.readflags && !this.user.readflags.operatorMessages.includes(targetMessage.id)) && targetMessage.user_id !== this.user.id) {
              this.newFlags.push(message.id);
            }
            // プレビュー本文は setMessage と同じく group の id でキーする（target_user_id 無しの type=4 衝突回避）
            this.messages[message.id] = targetMessage.message;
          }
        });
      }
    },

    loadMore() {
      this.getOperatorMessage();
    },
  },
};
</script>

<style lang="scss" module>

.message p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.new {
  position: absolute;
  background-color: var(--pink);
  color: #fff;
  font-weight: bold;
  font-size: 14px;
  padding: 4px 12px;
  border-radius: 4px;
  top: -3px;
  right: -3px;
  &_wrap {
    position: relative;
  }
}
.label {
  border-radius: 4px;
  margin-right: 4px;
  font-weight: bold;
  display: inline-block;
  &_wrap {
    display: flex;
    align-items: baseline;
  }
}
</style>
